import { useQuery } from '@apollo/client';
import type { UseSegmentsLinkedAudiences } from '@openx/components-segment/lib/utils/context/SegmentHookTypes.ts';
import { GetSegmentsWithLinkedAudiencesDocument } from '../../../graphql/query/segments/GetSegmentsWithLinkedAudiences.generated.tsx';

export const useSegmentsLinkedAudiences: UseSegmentsLinkedAudiences = ({ segmentIds }) => {
  const { loading, data: { segments = [] } = {} } = useQuery(GetSegmentsWithLinkedAudiencesDocument, {
    variables: {
      segmentIds,
    },
  });

  return {
    loading,
    segments,
  };
};
